import eCreditFetch from './acc_interceptor.ts';
import ServiceResponse from "@/types_and_interfaces/service_response_interface.ts";
import API_CLS from "@/utils/api.ts";

export const health = async () => {
    let response:ServiceResponse = {
        error: false,
    };
    
    
    try {
        const request = await eCreditFetch(API_CLS.common.health, {
            method: API_CLS.methods.Get,
        });
        
        response.status = request?.status
        
        
        if(response.status === 200) {
            response.message = "ok"
            
        } else {
            response.error = true
        }
        
        return response;
        
    } catch (error) {
        response.error = true;
        
        return response;
    }
}
export const get_build_info = async () => {
    let response:ServiceResponse = {
        error: false,
    };
    
    const is_local = import.meta.env.MODE === 'development'
    
    try {
        const request = is_local ? await fetch("https://client.dev.w.ecredit.md" + API_CLS.common.get_build_info, {
            method: API_CLS.methods.Get,
        })
        : await eCreditFetch(API_CLS.common.get_build_info, {
            method: API_CLS.methods.Get,
        })
        
        response.status = request?.status
        
        const body = await request.json();
        
        if(response.status === 200 && body.hasOwnProperty("build_info")) {
            response.message = "ok"
            response.response = body?.build_info
        } else {
            response.error = true
        }
        
        return response;
        
    } catch (error) {
        response.error = true;
        
        return response;
    }
}



